/**
 * Aviso Legal — LSSI-CE (Ley 34/2002) España
 * Adaptado para proyecto no comercial (creado por un conductor para sus compañeros)
 */
const AvisoLegal = () => {
    const sectionStyle = {
        marginBottom: '2rem'
    };

    const headingStyle = {
        fontSize: '1.3rem',
        fontWeight: 700,
        color: '#f1f5f9',
        marginBottom: '0.75rem',
        borderBottom: '1px solid rgba(56, 189, 248, 0.15)',
        paddingBottom: '0.5rem'
    };

    const textStyle = {
        color: '#94a3b8',
        lineHeight: 1.7,
        fontSize: '0.95rem',
        marginBottom: '0.75rem'
    };

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        marginBottom: '1rem',
        fontSize: '0.9rem'
    };

    const tdStyle = {
        padding: '0.6rem 0.75rem',
        borderBottom: '1px solid rgba(148, 163, 184, 0.1)',
        color: '#94a3b8'
    };

    return (
        <div>
            <h1 style={{
                fontSize: '1.8rem',
                fontWeight: 800,
                color: '#f8fafc',
                marginBottom: '0.5rem'
            }}>
                Aviso Legal
            </h1>
            <p style={{ color: '#64748b', fontSize: '0.85rem', marginBottom: '2rem' }}>
                Última actualización: 11 de marzo de 2026
            </p>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>1. Datos Identificativos</h2>
                <p style={textStyle}>
                    En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de
                    Servicios de la Sociedad de la Información y de Comercio Electrónico
                    (LSSI-CE), se informa:
                </p>
                <table style={tableStyle}>
                    <tbody>
                        <tr>
                            <td style={{ ...tdStyle, fontWeight: 600, color: '#cbd5e1', width: '35%' }}>Sitio web</td>
                            <td style={tdStyle}>https://calendario.xerp.es</td>
                        </tr>
                        <tr>
                            <td style={{ ...tdStyle, fontWeight: 600, color: '#cbd5e1' }}>Nombre de la aplicación</td>
                            <td style={tdStyle}>TUVISA Calendar</td>
                        </tr>
                        <tr>
                            <td style={{ ...tdStyle, fontWeight: 600, color: '#cbd5e1' }}>Administrador</td>
                            <td style={tdStyle}>Administrador de calendario.xerp.es</td>
                        </tr>
                        <tr>
                            <td style={{ ...tdStyle, fontWeight: 600, color: '#cbd5e1' }}>Email de contacto</td>
                            <td style={tdStyle}>info@xerp.es</td>
                        </tr>
                        <tr>
                            <td style={{ ...tdStyle, fontWeight: 600, color: '#cbd5e1' }}>Carácter</td>
                            <td style={tdStyle}>Herramienta interna no comercial, sin ánimo de lucro</td>
                        </tr>
                    </tbody>
                </table>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>2. Objeto del Sitio Web</h2>
                <p style={textStyle}>
                    TUVISA Calendar es una herramienta digital creada para facilitar la gestión
                    y consulta del calendario laboral de los conductores de autobuses urbanos de
                    Vitoria-Gasteiz. Permite a los conductores consultar sus turnos, libranzas,
                    vacaciones y realizar intercambios de días con compañeros.
                </p>
                <p style={textStyle}>
                    Se trata de un <strong>proyecto personal sin ánimo de lucro</strong>, desarrollado
                    por un conductor para uso interno de sus compañeros. No constituye un servicio
                    oficial de TUVISA ni de ninguna otra entidad empresarial.
                </p>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>3. Condiciones de Uso</h2>
                <p style={textStyle}>
                    El acceso a TUVISA Calendar requiere autenticación mediante cuenta de Google.
                    El usuario se compromete a:
                </p>
                <ul style={{
                    color: '#94a3b8',
                    lineHeight: 1.8,
                    paddingLeft: '1.5rem',
                    fontSize: '0.95rem',
                    marginBottom: '0.75rem'
                }}>
                    <li>Hacer un uso adecuado y lícito de la aplicación.</li>
                    <li>No manipular ni alterar datos que no le correspondan.</li>
                    <li>No realizar acciones que puedan dañar, inutilizar o sobrecargar el servicio.</li>
                    <li>Mantener la confidencialidad de su sesión y credenciales de acceso.</li>
                </ul>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>4. Propiedad Intelectual</h2>
                <p style={textStyle}>
                    El código fuente, diseño, estructura de navegación y demás elementos de
                    TUVISA Calendar están protegidos por las leyes de propiedad intelectual.
                    Queda prohibida su reproducción, distribución o modificación sin
                    autorización previa del administrador.
                </p>
                <p style={textStyle}>
                    Los datos del calendario laboral (turnos, libranzas, festivos) son propiedad
                    de TUVISA S.A. y se utilizan únicamente con fines informativos para los
                    trabajadores.
                </p>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>5. Limitación de Responsabilidad</h2>
                <p style={textStyle}>
                    El administrador no se responsabiliza de:
                </p>
                <ul style={{
                    color: '#94a3b8',
                    lineHeight: 1.8,
                    paddingLeft: '1.5rem',
                    fontSize: '0.95rem',
                    marginBottom: '0.75rem'
                }}>
                    <li>Posibles errores o desactualizaciones en los datos del calendario.
                        La información oficial es la que dispone TUVISA S.A. a través de sus
                        canales oficiales.</li>
                    <li>Interrupciones del servicio por causas técnicas, mantenimiento o
                        fuerza mayor.</li>
                    <li>Daños derivados del uso indebido de la aplicación por parte de los
                        usuarios.</li>
                </ul>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>6. Protección de Datos</h2>
                <p style={textStyle}>
                    Todo lo relativo a la protección de datos personales se encuentra detallado
                    en nuestra{' '}
                    <a href="/privacidad" style={{ color: '#38bdf8' }}>Política de Privacidad</a>.
                </p>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>7. Legislación Aplicable y Jurisdicción</h2>
                <p style={textStyle}>
                    Este aviso legal se rige por la legislación española vigente. Para la
                    resolución de cualquier controversia, las partes se someten a los
                    Juzgados y Tribunales de <strong>Vitoria-Gasteiz (Álava)</strong>,
                    renunciando a cualquier otro fuero que pudiera corresponderles.
                </p>
            </section>

            <div style={{
                marginTop: '2rem',
                padding: '1rem',
                borderRadius: '0.75rem',
                background: 'rgba(56, 189, 248, 0.05)',
                border: '1px solid rgba(56, 189, 248, 0.1)',
                textAlign: 'center'
            }}>
                <p style={{ color: '#64748b', fontSize: '0.85rem', margin: 0 }}>
                    ¿Tienes dudas? Escríbenos a{' '}
                    <a href="mailto:info@xerp.es" style={{ color: '#38bdf8' }}>info@xerp.es</a>
                </p>
            </div>
        </div>
    );
};

export default AvisoLegal;
